import { useBackend } from "../../services";

export const useReorderShelfSegmentAlbums = () => {
  const { post } = useBackend();
  const reorderShelfSegmentAlbums = (uuid: string, fromIndex: number, toIndex: number) => {
    return post("shelfSegments/albums/reorder", { uuid, fromIndex, toIndex });
  };
  return { reorderShelfSegmentAlbums };
};
